<template>
<div>
<v-container>
<div class="news_video pt-2 dirr">
    <div class="news_con d-none d-sm-flex">
        <div class="impoNews" v-if="impoNews_skeleton">
            <v-layout row>
                <v-flex sm12 xs12 md8 lg8 style="padding:0 10px;">
                    <v-skeleton-loader  width="800" min-width="800" type="image"></v-skeleton-loader>
                    <v-skeleton-loader  width="800" min-width="800" type="image"></v-skeleton-loader>
                    <v-skeleton-loader  width="800" min-width="800" type="card"></v-skeleton-loader>
                </v-flex>
                <v-flex sm12 xs12 md4 lg4 style="padding:0 10px;">
                    <v-skeleton-loader  class="mx-auto" width="350" min-width="350" max-width="350" type="paragraph, paragraph, paragraph, sentences, paragraph, sentences, sentences, paragraph, sentences, actions"></v-skeleton-loader>
                </v-flex>
            </v-layout>
        </div>
        <div class="impoNews" v-else>
            <!-- Header Section -->
            <div class="page-header" style="display: flex; align-items: center; justify-content: flex-start; gap: 30px;">
                <h1 class="main-title" style="margin: 0; white-space: nowrap; display: flex; align-items: center;">
                    {{ $t("adeb") }}
                </h1>
                <div class="section-tabs" style=" display: flex; gap: 20px;">
                    <span
                        v-for="(section, index) in allSections"
                        :key="section.id"
                        :class="['tab-item', { 'active': activeSection === section.id }]"
                        @click="selectSection(section.id)"
                        style="display: flex; align-items: center;"
                    >
                        <svg class="title-icon" viewBox="0 0 24 24" fill="none">
                            <path d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" stroke="currentColor" stroke-width="1.5"/>
                        </svg>
                        {{ section.title }}
                    </span>
                </div>
            </div>
            
            <!-- Featured Article -->
            <div class="featured-section">
                <router-link :to="'/new/'+i.id+'?lang='+$i18n.locale" v-for="i in impoNews.slice(0,1)" :key="i" class="featured-article">
                    <div class="article-grid">
                        <div class="article-image">
                            <v-img 
                                :lazy-src="'https://alkafeel.net/news/mcroped96/100/'+i.image"
                                :src="'https://alkafeel.net/news/mcroped96/800/'+i.image" 
                                aspect-ratio="1.6"
                            ></v-img>
                        </div>
                        <div class="article-content">
                            <h2 class="article-title">{{i.title}}</h2>
                            <p class="article-excerpt" v-html="removebbcode(i.text) + ' ...'"></p>
                            <div class="article-actions">
                                <span class="read-more">
                                    <svg class="read-icon" viewBox="0 0 24 24" fill="none" style="transform: scaleX(-1);">
                                        <path d="M17 8l4 4m0 0l-4 4m4-4H3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    اقرأ المزيد
                                </span>
                                <div class="share-buttons" @click.stop>
                                    <a
                                        :href="`https://telegram.me/share/?url=${encodeURIComponent('https://alkafeel.net/news/index?id=' + i.id + '&lang=' + $i18n.locale)}`"
                                        target="_blank"
                                        rel="noopener"
                                        class="share-btn"
                                        @click.stop
                                    >
                                        <svg class="share-icon" viewBox="0 0 24 24" fill="none">
                                            <path d="M21.426 4.337a1.5 1.5 0 0 0-1.626-.217L3.98 11.09a1.5 1.5 0 0 0 .13 2.77l3.77 1.44 1.44 3.77a1.5 1.5 0 0 0 2.77.13l6.97-15.82a1.5 1.5 0 0 0-.134-1.043zM9.5 15.5l7.5-7.5m0 0l-4.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        تلغرام
                                    </a>
                                    <a
                                        :href="`https://twitter.com/intent/tweet?url=${encodeURIComponent('https://alkafeel.net/news/index?id=' + i.id + '&lang=' + $i18n.locale)}`"
                                        target="_blank"
                                        rel="noopener"
                                        class="share-btn"
                                        @click.stop
                                    >
                                        <svg class="share-icon" viewBox="0 0 24 24" fill="none">
                                            <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z" stroke="currentColor" stroke-width="1.5"/>
                                        </svg>
                                        تويتر
                                    </a>
                                    <a
                                        :href="`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent('https://alkafeel.net/news/index?id=' + i.id + '&lang=' + $i18n.locale)}`"
                                        target="_blank"
                                        rel="noopener"
                                        class="share-btn"
                                        @click.stop
                                    >
                                        <svg class="share-icon" viewBox="0 0 24 24" fill="none">
                                            <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" stroke="currentColor" stroke-width="1.5"/>
                                        </svg>
                                        فيسبوك
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </router-link>
            </div>
            
            <!-- Secondary Articles -->
            <div class="secondary-section">
                <div class="articles-row">
                    <router-link 
                        v-for="i in impoNews.slice(1,4)" 
                        :key="i" 
                        :to="'/new/'+i.id+'?lang='+$i18n.locale" 
                        class="secondary-article"
                    >
                        <div class="secondary-image">
                            <v-img 
                                :lazy-src="'https://alkafeel.net/news/mcroped96/100/'+i.image"
                                :src="'https://alkafeel.net/news/mcroped96/625/'+i.image" 
                                aspect-ratio="1.3"
                            ></v-img>
                        </div>
                        <h3 class="secondary-title">{{i.title | subStrimpoNewsTitle}}</h3>
                    </router-link>
                </div>
            </div>
        </div>
        
        <!-- More Articles -->
        <div class="more-articles-section">
            <div class="articles-grid">
                <router-link 
                    v-for="i in MoreRes" 
                    :key="i" 
                    :to="'/new/' + i.id + '?&lang=' +$i18n.locale" 
                    class="grid-article"
                >
                    <div class="grid-image">
                        <v-img 
                            :lazy-src="'https://alkafeel.net/news/mcroped96/100/'+i.image"
                            :src="'https://alkafeel.net/news/mcroped96/260/'+i.image" 
                            aspect-ratio="1.3"
                        ></v-img>
                    </div>
                    <div class="grid-content">
                        <h4 class="grid-title">{{i.title}}</h4>
                        <div class="article-meta">
                            <span class="meta-category" v-if="$i18n.locale=='ar'">
                                <svg class="meta-icon" viewBox="0 0 24 24" fill="none">
                                    <path d="M7 7h10v3l4-4-4-4v3H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2v-9a2 2 0 00-2-2z" stroke="currentColor" stroke-width="1.5"/>
                                </svg>
                                {{i.cat_title}}
                            </span>
                            <span class="meta-date">
                                <svg class="meta-icon" viewBox="0 0 24 24" fill="none">
                                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="currentColor" stroke-width="1.5"/>
                                    <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" stroke-width="1.5"/>
                                    <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" stroke-width="1.5"/>
                                    <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" stroke-width="1.5"/>
                                </svg>
                                {{ i.time|FormatDate }}
                            </span>
                        </div>
                    </div>
                </router-link>
            </div>
            
            <div class="load-more-section" v-if="getMorenews">
                <button 
                    class="load-more-btn" 
                    :disabled="loading" 
                    @click="ShowMore()"
                >
                    <svg class="load-icon" viewBox="0 0 24 24" fill="none" v-if="loading">
                        <path d="M12 2v4m0 12v4M4.93 4.93l2.83 2.83m8.48 8.48l2.83 2.83M2 12h4m12 0h4M4.93 19.07l2.83-2.83m8.48-8.48l2.83-2.83" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s" from="0 12 12" to="360 12 12" repeatCount="indefinite"/>
                        </path>
                    </svg>
                    <svg class="load-icon" viewBox="0 0 24 24" fill="none" v-else>
                        <path d="M12 4v8l4-4m-4 4l-4-4m4 4v8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span v-if="loading">جاري التحميل...</span>
                    <span v-else>{{ $t('view_more') }}</span>
                </button>
            </div>
        </div>
    </div>
    
    <!-- Mobile Version -->
    <div class="mobile_con d-flex d-sm-none">
        <div class="mobile-header">
            <h1 class="mobile-title">
                <svg class="mobile-title-icon" viewBox="0 0 24 24" fill="none">
                    <path d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" stroke="currentColor" stroke-width="1.5"/>
                </svg>
                {{ $t("adeb") }}
            </h1>
            <div class="mobile-tabs">
                <span
                    v-for="(section, index) in allSections"
                    :key="section.id"
                    :class="['mobile-tab', { 'active': activeSection === section.id }]"
                    @click="selectSection(section.id)"
                >
                    {{ section.title }}
                </span>
            </div>
        </div>

        <div class="mobile-articles">
            <router-link 
                v-for="i in MobRes" 
                :key="i" 
                :to="'/new/'+i.id+'?lang='+$i18n.locale" 
                class="mobile-article"
            >
                <div class="mobile-image">
                    <v-img 
                        :lazy-src="'https://alkafeel.net/news/mcroped96/100/'+i.image"
                        :src="'https://alkafeel.net/news/mcroped96/625/'+i.image" 
                        aspect-ratio="1.5"
                    ></v-img>
                </div>
                <div class="mobile-content">
                    <h3 class="mobile-article-title">{{i.title}}</h3>
                </div>
            </router-link>
        </div>
        
        <div class="mobile-load-more" v-if="getMorenews">
            <button 
                class="load-more-btn mobile" 
                :disabled="loading" 
                @click="ShowMore()"
            >
                <svg class="load-icon mobile" viewBox="0 0 24 24" fill="none" v-if="loading">
                    <path d="M12 2v4m0 12v4M4.93 4.93l2.83 2.83m8.48 8.48l2.83 2.83M2 12h4m12 0h4M4.93 19.07l2.83-2.83m8.48-8.48l2.83-2.83" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s" from="0 12 12" to="360 12 12" repeatCount="indefinite"/>
                    </path>
                </svg>
                <svg class="load-icon mobile" viewBox="0 0 24 24" fill="none" v-else>
                    <path d="M12 4v8l4-4m-4 4l-4-4m4 4v8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span v-if="loading">جاري التحميل...</span>
                <span v-else>{{ $t('view_more') }}</span>
            </button>
        </div>
    </div>
</div>

<news-search></news-search>

</v-container>
</div>
</template>

<script>
import searchVue from './search.vue';
// import InfiniteLoading from 'vue-infinite-loading';
export default {
    data() {
        return {
            impoNews : [],
            MoreRes : [],
            MobRes : [],
            impoNews_skeleton : true,
            NewsPage : 1,
            getMorenews : true,
            loader: null,
            loading: false,
            swiperOptions2: {
                slidesPerView: 'auto',
                spaceBetween: 30,
                freeMode: true,
                keyboard: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
            },
            offsetTop: 0,
            axios_load: false,
            currentSlide: 0,
            activeSection: 1,
            allSections: [
                { id: 1, title: ' آفاق أدبية وثقافية' },
            ]
        }
    },
    watch: {
        loader () {
            const l = this.loader
            this[l] = !this[l]
            setTimeout(() => (this[l] = false), 2000)
            this.loader = null
        },
        offsetTop (val) {
            this.callbackFunc()
        }
    },
    components: {
        'news-search': searchVue
    },
    computed: {
        isRTL() {
            return this.$i18n.locale === 'ar';
        }
    },
    mounted() {
        document.title = this.$t("adeb");
        // انتظار حتى يتم تحميل البيانات وعرض الأزرار
        setTimeout(() => {
            this.calculateMaxScroll();
        }, 1000);
    },
    created () {
        this.getNews ();
        this.getSections ();
        if (! this.isMobileDevice()) {
            window.addEventListener('scroll', this.onScroll);
            }
    },
    methods:{
        onScroll (e) {
            setTimeout(() => {
                if (!this.axios_load) {this.offsetTop = window.pageYOffset || document.documentElement.scrollTop;}
            }, 700);
        },
        isElementInViewport(el) {
            var rect = el.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        },
        callbackFunc() {
            let el = document.querySelector('.getMorenews');
            if (this.isElementInViewport(el)) {this.ShowMore();}
        },
        getSections () {
            this.$axios.get("articles/adeb_sections/", {})
            .then(res => {
                this.allSections = res.data;
            });
        },
        getNews () {
            this.$axios.get("articles/Getadeb/8?page=" + this.NewsPage, {
            })
            .then(res => {
                this.NewsPage ++;
                this.impoNews = res.data.data;
                this.MoreRes = this.MoreRes.concat(this.impoNews.slice(4,8));
                this.MobRes = res.data.data;
                setTimeout(() => this.impoNews_skeleton = false, 500);
                this.ShowMore ();
            })
            .catch(() => {
            });
        },
        ShowMore () {
            this.axios_load = true;
            this.loader = 'loading';
            this.$axios.get("articles/Getadeb/8?page=" + this.NewsPage, {})
            .then(res => {
                this.axios_load = false;
                this.NewsPage ++;
                this.MoreRes = this.MoreRes.concat(res.data.data);
                this.MobRes = this.MobRes.concat(res.data.data);
                //this.NewsRes2 = res.data[0];
                if (res.data.data.length < 8) {this.getMorenews = false;}
                //setTimeout(() => this.lastNews_skeleton = false, 500);
                //console.log(res.data);
            })
            .catch(() => {
            });
        },   
        isMobileDevice() {
            var check = false;
            (function (a) {
                if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i
                    .test(a) ||
                    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i
                    .test(a.substr(0, 4))) check = true;
            })(navigator.userAgent || navigator.vendor || window.opera);
            return check;
        },
        removebbcode (x) {
            if (x) {return this.stripHTML(x.replace(/\[\/?[^\]]*\]/g, ''))}
        },
        stripHTML (value) {
            const div = document.createElement('div')
            div.innerHTML = value
            const text = div.textContent || div.innerText || ''
            return text
        },
        selectSection(sectionId) {
            this.activeSection = sectionId;
            // Navigate to news category page
            this.$router.push(`/newscat/${sectionId}?lang=${this.$i18n.locale}`);
        },
        slideLeft() {
            console.log('Slide left clicked, current position:', this.scrollPosition);
            if (this.isRTL) {
                // في العربية، السهم الأيسر يحرك المحتوى لليمين (قيمة موجبة)
                this.scrollPosition = Math.min(this.maxScrollPosition, this.scrollPosition + this.scrollStep);
            } else {
                // في الإنجليزية، السهم الأيسر يحرك المحتوى لليسار (قيمة سالبة)
                this.scrollPosition = Math.max(0, this.scrollPosition - this.scrollStep);
            }
        },
        slideRight() {
            console.log('Slide right clicked, current position:', this.scrollPosition, 'max:', this.maxScrollPosition);
            if (this.isRTL) {
                // في العربية، السهم الأيمن يحرك المحتوى لليسار (قيمة سالبة)
                this.scrollPosition = Math.max(0, this.scrollPosition - this.scrollStep);
            } else {
                // في الإنجليزية، السهم الأيمن يحرك المحتوى لليمين (قيمة موجبة)
                this.scrollPosition = Math.min(this.maxScrollPosition, this.scrollPosition + this.scrollStep);
            }
        },
        calculateMaxScroll() {
            this.$nextTick(() => {
                if (this.$refs.buttonsContainer) {
                    // حساب العرض المتاح للسلايدر
                    const visibleWidth = 800; // عرض ثابت تقريبي
                    const totalButtonsWidth = this.allSections.length * 170; // 150px + margins
                    this.maxScrollPosition = Math.max(0, totalButtonsWidth - visibleWidth);
                    console.log('Max scroll position:', this.maxScrollPosition);
                }
            });
        }
    },
    filters: {
        subStrArtTitle: function (string) {if (string != null) {return string.substring(0, 24) + '...';}},
        subStrlastNewsitle: function (string) {if (string != null) {return string.substring(0, 130) + '...';}},
        subStrimpoNewsTitle: function (string) {if (string != null) {return string.substring(0, 85) + '...';}},
        FormatDate: function (unixTime='1648050625') {
            let d = new Date(unixTime*1000);
            let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
            let mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(d);
            let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
            return (`${da}-${mo}-${ye}`);
        },
    },
}
</script>

<style scoped>
/* Icon Styles */
.title-icon {
    width: 24px;
    height: 24px;
    color: #7f8c8d;
    vertical-align: middle;
    margin: 0 8px;
}

.theme--dark .title-icon {
    color: #95a5a6;
}

.read-icon {
    width: 16px;
    height: 16px;
    margin-left: 5px;
    vertical-align: middle;
}

.share-icon {
    width: 14px;
    height: 14px;
    margin-left: 5px;
    vertical-align: middle;
}

.meta-icon {
    width: 14px;
    height: 14px;
    margin-left: 5px;
    vertical-align: middle;
    color: #95a5a6;
}

.load-icon {
    width: 16px;
    height: 16px;
    margin-left: 8px;
    vertical-align: middle;
}

.load-icon.mobile {
    width: 14px;
    height: 14px;
    margin-left: 6px;
}

.mobile-title-icon {
    width: 20px;
    height: 20px;
    color: #7f8c8d;
    vertical-align: middle;
}

.theme--dark .mobile-title-icon {
    color: #95a5a6;
}

/* Page Header */
.page-header {
    padding: 20px 30px 30px 30px;
    border-bottom: 1px solid #eee;
    margin-bottom: 30px;
}

.main-title {
    font-size: 28px;
    font-weight: 700;
    color: #2c3e50;
    margin: 0 0 20px 0;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}

.theme--dark .main-title {
    color: #ecf0f1;
}

.section-tabs {
    display: flex;
    justify-content: center;
    gap: 20px;
    flex-wrap: wrap;
}

.tab-item {
    padding: 10px 20px;
    cursor: pointer;
    color: #303030;
    font-weight: 500;
    border-bottom: 2px solid transparent;
    transition: all 0.3s ease;
    user-select: none;
}

.tab-item:hover {
    color: #34495e;
}

.tab-item.active {
    color: #2c3e50;
    border-bottom-color: #b1bd52;
}

.theme--dark .tab-item {
    color: #bdc3c7;
}

.theme--dark .tab-item:hover {
    color: #ecf0f1;
}

.theme--dark .tab-item.active {
    color: #ecf0f1;
    border-bottom-color: #b1bd52;
}

/* Featured Section */
.featured-section {
    padding: 0 30px 40px 30px;
    border-bottom: 1px solid #eee;
    margin-bottom: 40px;
}

.featured-article {
    display: block;
    text-decoration: none;
    color: inherit;
}

.article-grid {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 30px;
    align-items: start;
}

.article-image {
    border-radius: 12px;
    overflow: hidden;
}

.article-content {
    padding: 20px 0;
}

.article-title {
    font-size: 22px;
    font-weight: 600;
    color: #2c3e50;
    line-height: 1.4;
    margin: 0 0 15px 0;
}

.theme--dark .article-title {
    color: #ecf0f1;
}

.article-excerpt {
    font-size: 16px;
    color: #7f8c8d;
    line-height: 1.6;
    margin: 0 0 25px 0;
}

.theme--dark .article-excerpt {
    color: #bdc3c7;
}

.article-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.read-more {
    color: #b1bd52;
    font-weight: 500;
    font-size: 14px;
    display: flex;
    align-items: center;
}

.share-buttons {
    display: flex;
    gap: 15px;
}

.share-btn {
    color: #95a5a6;
    text-decoration: none;
    font-size: 13px;
    padding: 5px 10px;
    border-radius: 4px;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
}

.share-btn:hover {
    color: #b1bd52;
    background: #ecf0f1;
}

.theme--dark .share-btn {
    color: #7f8c8d;
}

.theme--dark .share-btn:hover {
    color: #b1bd52;
    background: #34495e;
}

/* Secondary Section */
.secondary-section {
    padding: 0 30px 40px 30px;
    border-bottom: 1px solid #eee;
    margin-bottom: 40px;
}

.articles-row {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 25px;
}

.secondary-article {
    display: block;
    text-decoration: none;
    color: inherit;
}

.secondary-image {
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 12px;
}

.secondary-title {
    font-size: 16px;
    font-weight: 500;
    color: #2c3e50;
    line-height: 1.4;
    margin: 0;
}

.theme--dark .secondary-title {
    color: #ecf0f1;
}

/* More Articles */
.more-articles-section {
    padding: 0 30px 30px 30px;
}

.articles-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
    margin-bottom: 40px;
}

.grid-article {
    display: block;
    text-decoration: none;
    color: inherit;
    padding: 20px;
    border-radius: 12px;
    transition: all 0.2s ease;
    border: 1px solid #ecf0f1;
}

.grid-article:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 20px rgba(0,0,0,0.1);
}

.theme--dark .grid-article {
    border-color: #34495e;
    background: #2c3e50;
}

.theme--dark .grid-article:hover {
    box-shadow: 0 4px 20px rgba(0,0,0,0.3);
}

.grid-image {
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 15px;
}

.grid-content {
    padding: 5px 0;
}

.grid-title {
    font-size: 16px;
    font-weight: 500;
    color: #2c3e50;
    line-height: 1.4;
    margin: 0 0 10px 0;
}

.theme--dark .grid-title {
    color: #ecf0f1;
}

.article-meta {
    display: flex;
    gap: 15px;
    font-size: 13px;
    color: #95a5a6;
}

.meta-category,
.meta-date {
    position: relative;
    display: flex;
    align-items: center;
}

.meta-category::after {
    content: "•";
    margin-left: 15px;
    color: #bdc3c7;
}

/* Load More */
.load-more-section {
    text-align: center;
    padding: 20px 0;
}

.load-more-btn {
    background: #b1bd52;
    color: white;
    border: none;
    padding: 12px 30px;
    border-radius: 25px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.load-more-btn:hover:not(:disabled) {
    background: #2980b9;
    transform: translateY(-1px);
}

.load-more-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* Mobile Styles */
.mobile_con {
    flex-direction: column;
    padding: 20px 15px;
}

.mobile-header {
    margin-bottom: 25px;
    text-align: center;
}

.mobile-title {
    font-size: 24px;
    font-weight: 700;
    color: #2c3e50;
    margin: 0 0 20px 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.theme--dark .mobile-title {
    color: #ecf0f1;
}

.mobile-tabs {
    display: flex;
    justify-content: center;
    gap: 10px;
    flex-wrap: wrap;
}

.mobile-tab {
    padding: 8px 16px;
    cursor: pointer;
    color: #7f8c8d;
    font-weight: 500;
    border-radius: 20px;
    transition: all 0.3s ease;
    font-size: 14px;
    user-select: none;
    border: 1px solid #ecf0f1;
}

.mobile-tab.active {
    color: white;
    background: #b1bd52;
    border-color: #b1bd52;
}

.theme--dark .mobile-tab {
    color: #bdc3c7;
    border-color: #34495e;
}

.theme--dark .mobile-tab.active {
    color: white;
    background: #b1bd52;
    border-color: #b1bd52;
}

.mobile-articles {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.mobile-article {
    display: block;
    text-decoration: none;
    color: inherit;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #ecf0f1;
}

.theme--dark .mobile-article {
    border-color: #34495e;
    background: #2c3e50;
}

.mobile-image {
    width: 100%;
}

.mobile-content {
    padding: 15px 20px;
}

.mobile-article-title {
    font-size: 16px;
    font-weight: 500;
    color: #2c3e50;
    line-height: 1.4;
    margin: 0;
}

.theme--dark .mobile-article-title {
    color: #ecf0f1;
}

.mobile-load-more {
    text-align: center;
    margin-top: 25px;
}

.load-more-btn.mobile {
    padding: 10px 25px;
    font-size: 14px;
}

/* Responsive Design */
@media (max-width: 768px) {
    .article-grid {
        grid-template-columns: 1fr;
        gap: 20px;
    }
    
    .articles-row {
        grid-template-columns: 1fr;
        gap: 20px;
    }
    
    .articles-grid {
        grid-template-columns: 1fr;
        gap: 20px;
    }
    
    .page-header {
        padding: 15px 20px 20px 20px;
    }
    
    .featured-section,
    .secondary-section,
    .more-articles-section {
        padding: 0 20px 30px 20px;
    }
}

@media (max-width: 480px) {
    .main-title {
        font-size: 22px;
    }
    
    .article-title {
        font-size: 18px;
    }
    
    .mobile-tab {
        font-size: 12px;
        padding: 6px 12px;
    }
}
</style>